import { render, staticRenderFns } from "./CustomSlideDeckButton.vue?vue&type=template&id=ec4771e2"
import script from "./CustomSlideDeckButton.vue?vue&type=script&lang=ts"
export * from "./CustomSlideDeckButton.vue?vue&type=script&lang=ts"
import style0 from "./CustomSlideDeckButton.vue?vue&type=style&index=0&id=ec4771e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports